module.exports = __webpack_public_path__ + "static/media/altoplay.023944ef.JPG";